import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';

import SmallLoader from '../../../../../../../img/small-loader.gif';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
//import { MODULE } from './constants/ApiConstants';
import validate from './validate';
import { getSkillAcquisitionArchvedDomainList,getSkillAcquisitionArchivedProgramList, getSkillAcquisitionArchivedTargetList } from './actions/skillAquisitionDomainActions';
import { UpdateDCBatchUnarchiveStatus } from '../../../../../../MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions';

class BatchUnarchiveSkillAcquisitionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          open: true,          
          patientId: props.patientId,          
          actionName: '',
          ids: '',
        };
    }

    componentWillMount() {      
       this.props.getSkillAcquisitionArchvedDomainList(this.state.patientId)
    }
    

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {          
          this.setState({ open: false });
          this.props.closeDialog();
        }
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode === 27) {
            self.handleClose();
          }
        };
    }

    renderLoading() {
        return (
          <div>
            {this.props.loading ? (
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
            ) : null}
          </div>
        );
    }

    onSubmitHandler(formProps) {          
      if(this.state.actionName !== '') {
        this.props.UpdateDCBatchUnarchiveStatus(this.state.ids.toString(), false, this.state.actionName);        
        this.props.closeDialog();       
      }             
    }
    
    handleNewRequestDomain = (input, selectedRecord) => {      
      let skillsAcquisitionDomainId = this.props.skillAcquisitionArchivedDomainList && this.props.skillAcquisitionArchivedDomainList.data && this.props.skillAcquisitionArchivedDomainList.data.filter((op) => op.id === selectedRecord.value)[0].skillsAcquisitionDomainId;      
      this.setState({ids: skillsAcquisitionDomainId, actionName: 'SkillAcquisitionDomain'},()=>{
        input.onChange(selectedRecord.value);
        this.props.getSkillAcquisitionArchivedProgramList(this.state.patientId, selectedRecord.value);
      });    
    };

    handleNewRequestProgram = (input, selectedRecord) => {      
      this.setState({ids: selectedRecord.value, actionName: 'SkillAcquisitionProgram'},()=>{
        input.onChange(selectedRecord.value); 
        this.props.getSkillAcquisitionArchivedTargetList(this.state.patientId, selectedRecord.value);
      });    
    };

    handleNewRequestTarget = (input, selectedRecord) => {                      
      this.setState({ids: selectedRecord, actionName: 'SkillAcquisitionTarget'},()=>{input.onChange(selectedRecord); });            
    }
    

    render() {
       let skillAcquisitionArchivedDomainList = this.props.skillAcquisitionArchivedDomainList !== null && this.props.skillAcquisitionArchivedDomainList;
       let skillAcquisitionArchivedProgramList = this.props.skillAcquisitionArchivedProgramList !== null && this.props.skillAcquisitionArchivedProgramList;
       let skillAcquisitionArchivedTargetList = this.props.skillAcquisitionArchivedTargetList !== null && this.props.skillAcquisitionArchivedTargetList;
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
        <SubmitButtonModalDisabled label="Loading" /> :
        <SubmitButtonModal label="Unarchive" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
          ];
        return (
            <Dialog
            className="custom_modal"
            title={"Batch Unarchive"}
            modal={false}
            open={this.state.open}
            actions={actions}
            autoScrollBodyContent={true}
          >
            {this.renderLoading()}
            <div className="row">
              <div className="col-sm-12">
                <form
                  className="readmin-form custom_form"
                  onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
                >
                  <div className="row">                    
                    <div className="col-sm-12 require mt-25">
                      <Field
                        autoFocus={true}
                        name="domainId"  
                        label="Domain Name"      
                        handleNewRequest={this.handleNewRequestDomain}
                        options={skillAcquisitionArchivedDomainList.data}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12 mt-25">
                      <Field
                        autoFocus={true}
                        name="programId"  
                        label="Program Name"      
                        handleNewRequest={this.handleNewRequestProgram}
                        options={skillAcquisitionArchivedProgramList.data}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12 mt-25">
                      <Field
                        autoFocus={true}
                        name="targetId"  
                        label="Target Name"      
                        handleNewRequest={this.handleNewRequestTarget}
                        options={skillAcquisitionArchivedTargetList.data}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>
                  </div>                
                </form>
              </div>
            </div>
          </Dialog>
        )
    }
}

BatchUnarchiveSkillAcquisitionModal = reduxForm({
    form: 'BatchUnarchiveSkillAcquisitionModalForm',
    validate,
    enableReinitialize: true,
})(BatchUnarchiveSkillAcquisitionModal);

function mapStateToProps(state, props) {
    return {
        loading: state.domain.loading || state.skillAcquisitionDomain.loading,        
        skillAcquisitionArchivedDomainList: state.skillAcquisitionDomain.skillAcquisitionArchivedDomainList,
        skillAcquisitionArchivedProgramList: state.skillAcquisitionDomain.skillAcquisitionArchivedProgramList,
        skillAcquisitionArchivedTargetList: state.skillAcquisitionDomain.skillAcquisitionArchivedTargetList,        
      }
}


export default connect(mapStateToProps, {  UpdateDCBatchUnarchiveStatus, getSkillAcquisitionArchvedDomainList, getSkillAcquisitionArchivedProgramList, getSkillAcquisitionArchivedTargetList}) (BatchUnarchiveSkillAcquisitionModal)



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/BatchUnarchiveSkillAcquisition_Modal.js